module.exports = __webpack_public_path__ + "static/media/position-ucg.ab290740.jpg";